import React from 'react';
import ReactDOM from 'react-dom/client';
import './ipad-landscape.js';
import './driver.css';
import DriverApp from './DriverApp.js';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

ReactDOM.createRoot(root).render(
  React.createElement(DriverApp)
);
